import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { FlowerLogo } from "./FlowerLogo";
import { Send } from "lucide-react";
import { useI18n } from "../lib/i18n";

export const Faq = () => {
  const { t } = useI18n();
  return (
  <section id="faq" className="border-t border-[#30363D]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-4">
        <p className="font-mono text-xs text-[#38BDF8]">{t("faqEyebrow")}</p>
        <h2 className="mt-2 text-2xl sm:text-3xl font-bold tracking-tight">{t("faqTitle")}</h2>
      </div>
      <Accordion type="single" collapsible className="lg:col-span-8">
        {t("faqs").map(([q, a], i) => (
          <AccordionItem key={i} value={`f${i}`} className="border-[#30363D]">
            <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-display text-base hover:no-underline hover:text-[#3FB950]">{q}</AccordionTrigger>
            <AccordionContent className="text-[#8B949E] leading-relaxed">{a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
  );
};

export const Footer = () => {
  const { t } = useI18n();
  return (
  <footer className="border-t border-[#30363D]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-10 flex flex-wrap items-center justify-between gap-4 text-sm text-[#6E7681]">
      <div className="flex items-center gap-2">
        <FlowerLogo size={20} /> <span className="font-display font-bold text-[#F0F6FC]">KICQ</span> · {t("tagline")}
      </div>
      <div className="flex items-center gap-6">
        <a href="https://t.me/kicq_official" target="_blank" rel="noopener noreferrer" data-testid="footer-telegram-btn"
          className="inline-flex items-center gap-2 rounded-full bg-[#229ED9] px-4 py-2 text-sm font-semibold text-white hover:bg-[#1c8cc2] transition-colors">
          <Send className="h-4 w-4" /> Telegram
        </a>
        <a href="https://kicq.su" target="_blank" rel="noopener noreferrer" data-testid="footer-webclient-link"
          className="text-[#38BDF8] hover:text-[#F0F6FC] transition-colors">{t("footWeb")}</a>
        <span className="font-mono text-xs">OSCAR · 195.66.114.37:5190</span>
      </div>
    </div>
  </footer>
  );
};
